import { CheckIcon } from "./icons";

const StepIndicator = ({ currentStep, totalSteps = 5 }) => (
  <div className="flex items-center gap-2">
    {Array.from({ length: totalSteps }, (_, i) => {
      const stepNum = i + 1;
      const isCompleted = stepNum < currentStep;
      const isCurrent = stepNum === currentStep;

      return (
        <div key={stepNum} className="flex items-center">
          <div
            className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold transition-all ${
              isCompleted
                ? "bg-white text-teal-600"
                : isCurrent
                ? "bg-white text-teal-600 ring-2 ring-white ring-offset-2 ring-offset-teal-600"
                : "bg-teal-500/30 text-white/70"
            }`}
          >
            {isCompleted ? <CheckIcon /> : stepNum}
          </div>
          {stepNum < totalSteps && (
            <div className={`w-8 h-0.5 mx-1 ${stepNum < currentStep ? "bg-white" : "bg-teal-500/30"}`} />
          )}
        </div>
      );
    })}
  </div>
);

export default StepIndicator;
